import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";

import executon from "./Executon-Slice";
import PageOverview from "./PageOverview";
import vendorMaster from "./VendorMaster";
import pageMaster from "./PageMaster";
import PageSlice from "./Page-slice";

import { reduxBaseURL } from "./reduxBaseURL";
import { PageBaseURL } from "./PageBaseURL";
import { salesReducers } from "./Reducer/SalesReducer";
import { salesMiddlewares } from "./Middleware/SalesMiddleware";

// RTK Query APIs
import TagCategoryApi from "./API/Inventory/TagCategoryAPI";
import CatAssignment from "./API/Inventory/CatAssignment";
import InvoiceRequestApi from "./API/Finance/InvoiceRequestApi";
import OutstandingApi from "./API/Finance/OutstandingApi";
import SaleBookingTdsApi from "./API/Finance/SaleBookingTdsApi";
import FinanceSalesApi from "./API/Finance/FinanceSalesApi";
import OperationApi from "./API/Operation/OperationApi";
import PurchaseRequestPaymentApi from "./API/Purchase/PurchaseRequestPaymentApi";
import DirectPurchaseApi from "./API/Purchase/DirectPurchaseApi";
import { purchaseApi } from "../Purchase/api/purchaseApiSlice";
import PantryApi from "./API/Pantry/PantryApi";
import BoostingApi from "./API/Boosting/BoostingApi";
import vendorSaleApi from "./API/VendorSale/VendorSaleApi";
import communityInternalCatApi from "./API/Community/CommunityInternalCatApi";
import CommunityNewApi from "./API/Community/CommunityNewApi";
import UsersApi from "./API/HRMS/UserApi";
import WFHDApi from "./API/HRMS/WFHDApi";
import SittingApi from "./API/HRMS/SittingApi";
import PlanxAPi from "./API/Inventory/PlanxAPi";
import BulkVendorAPi from "./API/Inventory/BulkVendorAPi";
import DashboardAPI from "./API/Inventory/DashboardAPI";
import OverviewApi from "./API/Inventory/OverviewApi";
import PageAPI from "./API/Inventory/PageAPI";
import UserLoginAPI from "./API/Login/UserLoginAPI";
import TableApi from "./API/CustomTable/TableApi";
import UserDashboardApi from "./API/HRMS/UserDashboardApi";
import HobbieApi from "./API/HRMS/HobbieApi";
import JobTypeApi from "./API/HRMS/JobTypeApi";
import ObjectApi from "./API/HRMS/ObjectApi";
import RoleApi from "./API/HRMS/RoleApi";
import AuthAPI from "./API/Auth/AuthAPI";
import DepartmentApi from "./API/HRMS/DepartmentApi";
import MajorDepartmentApi from "./API/HRMS/MajorDepartmentApi";
import SubDepartmentApi from "./API/HRMS/SubDepartmentApi";
import DesignationApi from "./API/HRMS/DesignationApi";
import SalaryApi from "./API/HRMS/SalaryApi";
import AttandanceApi from "./API/HRMS/AttendanceApi";
import SarcasmApi from "./API/Sarcasm/SarcasmApi";
import AdvancePurchaseApi from "./API/Purchase/AdvancePurchaseApi";
import ExecutionApi from "./API/Execution/ExecutionApi";
import RecoveryApi from "./API/Recovery/RecoveryApi";
import EmailReportApi from "./API/ReportApi/EmailReport";

const store = configureStore({
  reducer: {
    ...salesReducers,

    executon,
    PageOverview,
    vendorMaster,
    pageMaster,
    PageSlice,

    [reduxBaseURL.reducerPath]: reduxBaseURL.reducer,
    [PageBaseURL.reducerPath]: PageBaseURL.reducer,
    [purchaseApi.reducerPath]: purchaseApi.reducer,

    [TagCategoryApi.reducerPath]: TagCategoryApi.reducer,
    [CatAssignment.reducerPath]: CatAssignment.reducer,
    [OutstandingApi.reducerPath]: OutstandingApi.reducer,
    [InvoiceRequestApi.reducerPath]: InvoiceRequestApi.reducer,
    [SaleBookingTdsApi.reducerPath]: SaleBookingTdsApi.reducer,
    [FinanceSalesApi.reducerPath]: FinanceSalesApi.reducer,
    [OperationApi.reducerPath]: OperationApi.reducer,
    [PurchaseRequestPaymentApi.reducerPath]: PurchaseRequestPaymentApi.reducer,
    [DirectPurchaseApi.reducerPath]: DirectPurchaseApi.reducer,
    [AdvancePurchaseApi.reducerPath]: AdvancePurchaseApi.reducer,
    [PantryApi.reducerPath]: PantryApi.reducer,
    [BoostingApi.reducerPath]: BoostingApi.reducer,
    [UsersApi.reducerPath]: UsersApi.reducer,
    [WFHDApi.reducerPath]: WFHDApi.reducer,
    [SittingApi.reducerPath]: SittingApi.reducer,
    [UserDashboardApi.reducerPath]: UserDashboardApi.reducer,
    [HobbieApi.reducerPath]: HobbieApi.reducer,
    [JobTypeApi.reducerPath]: JobTypeApi.reducer,
    [ObjectApi.reducerPath]: ObjectApi.reducer,
    [RoleApi.reducerPath]: RoleApi.reducer,
    [AuthAPI.reducerPath]: AuthAPI.reducer, // ✅ ONLY ONCE
    [DepartmentApi.reducerPath]: DepartmentApi.reducer,
    [MajorDepartmentApi.reducerPath]: MajorDepartmentApi.reducer,
    [SubDepartmentApi.reducerPath]: SubDepartmentApi.reducer,
    [DesignationApi.reducerPath]: DesignationApi.reducer,
    [vendorSaleApi.reducerPath]: vendorSaleApi.reducer,
    [communityInternalCatApi.reducerPath]: communityInternalCatApi.reducer,
    [CommunityNewApi.reducerPath]: CommunityNewApi.reducer,
    [PlanxAPi.reducerPath]: PlanxAPi.reducer,
    [BulkVendorAPi.reducerPath]: BulkVendorAPi.reducer,
    [DashboardAPI.reducerPath]: DashboardAPI.reducer,
    [OverviewApi.reducerPath]: OverviewApi.reducer,
    [PageAPI.reducerPath]: PageAPI.reducer,
    [UserLoginAPI.reducerPath]: UserLoginAPI.reducer,
    [TableApi.reducerPath]: TableApi.reducer,
    [SalaryApi.reducerPath]: SalaryApi.reducer,
    [AttandanceApi.reducerPath]: AttandanceApi.reducer,
    [SarcasmApi.reducerPath]: SarcasmApi.reducer,
    [ExecutionApi.reducerPath]: ExecutionApi.reducer,
    [RecoveryApi.reducerPath]: RecoveryApi.reducer,
    [EmailReportApi.reducerPath]: EmailReportApi.reducer,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(...salesMiddlewares)
      .concat(
        reduxBaseURL.middleware,
        PageBaseURL.middleware,
        purchaseApi.middleware,
        TagCategoryApi.middleware,
        CatAssignment.middleware,
        OutstandingApi.middleware,
        InvoiceRequestApi.middleware,
        SaleBookingTdsApi.middleware,
        FinanceSalesApi.middleware,
        OperationApi.middleware,
        PurchaseRequestPaymentApi.middleware,
        DirectPurchaseApi.middleware,
        AdvancePurchaseApi.middleware,
        PantryApi.middleware,
        BoostingApi.middleware,
        UsersApi.middleware,
        WFHDApi.middleware,
        SittingApi.middleware,
        UserDashboardApi.middleware,
        HobbieApi.middleware,
        JobTypeApi.middleware,
        ObjectApi.middleware,
        RoleApi.middleware,
        AuthAPI.middleware, // ✅ ONLY ONCE
        DepartmentApi.middleware,
        MajorDepartmentApi.middleware,
        SubDepartmentApi.middleware,
        DesignationApi.middleware,
        vendorSaleApi.middleware,
        communityInternalCatApi.middleware,
        CommunityNewApi.middleware,
        PlanxAPi.middleware,
        BulkVendorAPi.middleware,
        DashboardAPI.middleware,
        OverviewApi.middleware,
        PageAPI.middleware,
        UserLoginAPI.middleware,
        TableApi.middleware,
        SalaryApi.middleware,
        AttandanceApi.middleware,
        SarcasmApi.middleware,
        ExecutionApi.middleware,
        RecoveryApi.middleware,
        EmailReportApi.middleware
      ),
});

setupListeners(store.dispatch);
export default store;
